import {o_shoppages} from './shoppages.js';
import {eventLoader} from '@otto-ec/global-resources/event-loader';

function initEventHandler () {
  if (!window.shoppagesAccordionInitialized) {
    window.shoppagesAccordionInitialized = true;
    window.addEventListener('hashchange', openByHash);
  }
}
function openByHash () {
  const hash = window.location.hash;
  if (hash === null || !hash.match(/^#(\w+)/)) {
    return false;
  }
  const element = document.getElementById(RegExp.$1);
  if (element === null) {
    return false;
  }
  if (!element.classList.contains('js_shoppages_accordion')) {
    return false;
  }
  element.setAttribute('expanded', 'true');
  return true;
}

o_shoppages.accordion = {

  handlePageLoad (): void {
    if (!openByHash()) {
      const accordion_header = document.querySelector('.js_shoppages_accordion');
      if (accordion_header !== null) {
        accordion_header.setAttribute('expanded', 'true');
      }
    }
  },

  init (): void {
    this.handlePageLoad();
    initEventHandler();
  }

};

eventLoader.onLoad(100, () => {
  o_shoppages.accordion.init();
});
